export default {
  namespaced: true,
  state: {
    showCheckbox: true,
    bannerVisible: true,
  },
  mutations: {
    setShowCheckbox(state, value) {
      state.showCheckbox = value;
    },
    setBannerVisible(state, value) {
      state.bannerVisible = value;
    },
  },
  actions: {
    updateShowCheckbox({ commit }, value) {
      commit('setShowCheckbox', value);
    },
    updateBannerVisible({ commit }, value) {
      commit('setBannerVisible', value);
    },
  },
  getters: {
    showCheckbox: (state) => state.showCheckbox,
    bannerVisible: (state) => state.bannerVisible,
  },
};
